export const REQUEST_BOARD_COLUMN_INITIAL_COUNT = 0

export const REQUEST_BOARD_COLUMN_INITIAL_PAGE_OFFSET = 0

export const REQUEST_BOARD_COLUMN_THRESHOLD_END_INDEX = 0

export const REQUEST_BOARD_COLUMN_OBSERVER_OPTIONS = { threshold: 0 }
